import { spacingValue, } from '@smoothie-framework/ui-core';
const SPACING_PROPERTIES = new Set([
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingStart',
    'paddingEnd',
    'paddingX',
    'paddingY',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'gap',
]);
const SHORTHAND_MAPPINGS = {
    paddingX: ['paddingLeft', 'paddingRight'],
    paddingY: ['paddingTop', 'paddingBottom'],
    marginX: ['marginLeft', 'marginRight'],
    marginY: ['marginTop', 'marginBottom'],
};
function toKebabCase(value) {
    return value.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
}
function normalizeResolvedStyleValue(prop, value) {
    if (typeof value === 'number') {
        if (SPACING_PROPERTIES.has(prop)) {
            return spacingValue(value);
        }
        return String(value);
    }
    return value;
}
/** Convert a resolved recipe style object to an inline CSS string. */
export function recipeStylesToWebStyle(styles) {
    const cssRules = [];
    for (const [prop, value] of Object.entries(styles)) {
        if (value === undefined || value === null) {
            continue;
        }
        if (SHORTHAND_MAPPINGS[prop]) {
            const expandedProps = SHORTHAND_MAPPINGS[prop];
            for (const expandedProp of expandedProps) {
                const cssValue = normalizeResolvedStyleValue(expandedProp, value);
                cssRules.push(`${toKebabCase(expandedProp)}: ${cssValue}`);
            }
            continue;
        }
        const cssValue = normalizeResolvedStyleValue(prop, value);
        const cssProp = prop.startsWith('--') ? prop : toKebabCase(prop);
        cssRules.push(`${cssProp}: ${cssValue}`);
    }
    return cssRules.join('; ');
}
export function styleValueToString(style) {
    if (!style) {
        return undefined;
    }
    if (typeof style === 'string') {
        const trimmed = style.trim();
        return trimmed.length > 0 ? trimmed : undefined;
    }
    const parts = [];
    for (const [key, value] of Object.entries(style)) {
        if (value === undefined || value === null) {
            continue;
        }
        const cssKey = key.startsWith('--') ? key : toKebabCase(key);
        parts.push(`${cssKey}: ${String(value)}`);
    }
    return parts.length > 0 ? parts.join('; ') : undefined;
}
export function mergeStyleStrings(baseParts, style) {
    const external = styleValueToString(style);
    const parts = external ? [...baseParts, external] : baseParts;
    return parts.length > 0 ? parts.join('; ') : undefined;
}
//# sourceMappingURL=style.js.map